import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MxBaseComponent } from 'src/app/core/base/mx.base-component';

@Component({
 standalone: false,
  selector: 'mx-table-caption-button',
  templateUrl: './mx.table-caption-button.component.html',
  styleUrls: ['./mx.table-caption-button.component.scss'],
})
export class MxTableCaptionButtonComponent extends MxBaseComponent {
  @Input() tooltip: string;
  @Input() label: string;
  @Input() icon: string;
  @Input() styleClass: string;
  @Input() type: string = 'outlined';
  @Input() spacing: string = 'mr-2';
  @Input() loading: boolean;
  @Input() disabled: boolean;
  @Input() visible: boolean = true;

  @Output() onClick: EventEmitter<any> = new EventEmitter<any>();

  get tooltipText(): string {
    if (!this.tooltip) {
      return this.tooltip;
    }

    try {
      let normalized = this.tooltip;

      for (let i = 0; i < 3; i++) {
        const decoded = decodeURIComponent(escape(normalized));
        if (decoded === normalized) {
          break;
        }

        normalized = decoded;
      }

      return normalized;
    } catch {
      return this.tooltip;
    }
  }
}

